export default __webpack_public_path__ + "static/media/hotei04.b0803c8c.webp";